import * as React from 'react';
import { Input } from 'antd';
import Doc from 'src/utils/Doc'

const css = require('./index.scss');

export interface  IProps {
    type?: ('input' | 'textarea'); //输入框类型
    maxLength?: number;
    placeholder?: string;
    onChange?: (e:any) => void;
    value?:string;
    style?: any;
    rows?: number;
    disabled?:boolean;
    key?:string;
    onBlur?: (e:any) => void;
    autosize?: any;
    readOnly?:boolean;
    autoComplete?:string;
}

export default function CommonInput(props: IProps) {

    const [value, setValue] = React.useState(props.value);

    const changeValue = (e) => {
        setValue(e.target.value);
        if(props.onChange) {props.onChange(e);}
    };
    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);
    const ComponentName = props.type === 'textarea' ? Input.TextArea : Input; 
    const maxLength = props.maxLength ?  props.maxLength : 50;
    const length = Doc.Check.getLength(value);

    return (
        <div className={css.inputBox}>
            <ComponentName {...props} onChange={changeValue} value={value} maxLength={maxLength} autoComplete="off"/>
            {length >=maxLength ?<span className={css.message}>{length}/{maxLength}</span>:null}
        </div>
    );
}


// WEBPACK FOOTER //
// ./src/display/components/CommonInput/index.tsx